import classNames from 'classnames'

import { useMenuCollapsedState } from '../../../hooks'
import { Main } from '../../Main'

import * as styles from './LayoutMain.module.css'

function LayoutMain({ children, className }) {
  const [collapsed] = useMenuCollapsedState()

  const mainClassName = classNames(className, styles.main, {
    [styles.collapsed]: collapsed,
  })

  return <Main className={mainClassName}>{children}</Main>
}

export default LayoutMain
